export const orderTabs = [
  { label: "New", status: "pending" },
  { label: "Processing", status: "processing" },
  { label: "Shipped", status: "shipped" },
  { label: "Cancelled", status: "cancelled" },
  { label: "All", status: "all" },
];

export const emptyOrderForm = {
  customerName: "",
  customerEmail: "",
  channel: "direct",
  status: "processing",
  paymentStatus: "paid",
  itemName: "",
  itemSku: "",
  quantity: 1,
  price: "",
  shipping: 0,
  tax: 0,
  line1: "",
  city: "",
  state: "",
  postalCode: "",
  country: "US",
};

export const emptyEditForm = {
  status: "processing",
  paymentStatus: "paid",
  channel: "direct",
  fraudFlag: false,
  adminNotes: "",
  line1: "",
  city: "",
  state: "",
  postalCode: "",
  country: "US",
};

export function formatMoney(value) {
  return `$${Number(value || 0).toFixed(2)}`;
}

export function statusTone(status) {
  if (status === "shipped" || status === "delivered") return "good";
  if (status === "cancelled" || status === "returned") return "bad";
  if (status === "processing") return "info";
  return "warn";
}

export function paymentTone(status) {
  if (status === "paid") return "good";
  if (status === "failed") return "bad";
  return "warn";
}

export function normalizeOrder(order) {
  return {
    ...order,
    _id: order._id || order.id,
    user: order.user || { name: "Guest", email: "" },
    items: order.items || [],
    shippingAddress: order.shippingAddress || {},
  };
}

export function orderAddress(order) {
  const address = order?.shippingAddress || {};
  return [address.line1, address.city, address.state, address.postalCode, address.country].filter(Boolean).join(", ");
}
